import React, { useState, useContext, Component, createRef } from "react";
import { Container, Row, Button, Col, Nav, Table, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import { getCurrentDateTime } from "../../helper";
import CartContext from "./CartContext";
import { Navigate } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import { Country, State, City } from "country-state-city";

export default class CompleteOrder extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      intervalId: "",
      timerExpired: false,
      firstLoad: false,
      invoiceHtml: "",
      refresh: false,
    };
  }

  PrintInvoice = () => {
    var printWindow = window.open("", "", "height=1000,width=1500");
    //var printWindow = window.open("", "");
    printWindow.document.write(this.state.invoiceHtml);
    printWindow.document.close();
    this.onPrintFinished(printWindow.print(), printWindow);
  };
  onPrintFinished = (status, printWindow) => {
    printWindow.close();
  };

  GetInvoice = () => {
    fetch(
      process.env.REACT_APP_API +
        "Sales/GetElasticCartInvoiceHtml/" +
        this.context.orderData.orderId
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else {
          var d1 = document.getElementById("one");
          if (d1) {
            this.setState({ invoiceHtml: data }, () => {
              d1.innerHTML = data;
              console.log(data);
            });
            this.setState({ refresh: true });
          }
        }
      })
      .catch((error) => {
        console.error("There was an error!", error);
        alert("Error GetInvoice:" + error);
      });
  };
  componentDidMount() {
    window.scrollTo(0, 0);
    if (this.state.firstLoad == false) {
      this.state.firstLoad = true;
      this.GetInvoice();
    }
  }
  componentWillUnmount() {}

  render() {
    if (this.context.userData.loginStatus != "active")
      return <Navigate to="/home" />;

    if (this.context.OrderStatus === "Success") {
      return (
        <>
          <br></br>
          <div className="row mt-1 mx-1 px-0">
            <div className="col-md-2"></div>
            <div className="col-md-8 bg-white mb-5 invoiceDsnSec">
              {/* <Row className="text-center">
                <Col className=" text-center ">
                  <h1 className="mb-3 mt-3">
                    <b>Invoice</b>
                  </h1>
                </Col>
              </Row>
              <Row className="">
                <Col className="text-start ms-4 text-success">
                  <h5 class="text-dark ">
                    Order No: <b>{this.context.orderData.orderId}</b>
                  </h5>
                </Col>
                <Col className="text-end me-4 text-dark">
                  <h5 class="text-dark ">
                    {" "}
                    Date:
                    <b>{this.context.GetInDateFormat(new Date())}</b>
                  </h5>
                </Col>
              </Row> */}

              <div className="mx-3 px-3 text-end">
                <Button as={Link} to={"/MyProducts"}>
                  My Products
                </Button>{" "}
                &nbsp;
                <Button as={Link} to={"/MyOrders"}>
                  My Orders
                </Button>{" "}
                {/* &nbsp;
                <Button onClick={(e) => this.PrintInvoice()}>
                  Print/Download Invoice
                </Button> */}
                <br></br>
                <h4 className="text-success text-center invoiceSuccessMsgDsn mb-3">
                  <span>
                    <div id="one"></div>
                  </span>
                </h4>
              </div>
              <div className="col-md-2"></div>
            </div>
          </div>
        </>
      );
    }
  }
}
